<template>
  <div class="app-wrapper-frame">
    <div class="main-container">
      <div class="main-wrapper ccui-main-wrapper">
        <div class="iframeHeadWrap" v-if="menuShow">
          <div class="iframeHeadLogo" :title="bidFuncName">
            <!--            <img :src="bidFlowLogo" />-->
            <img class="iframe-Logo" :src="bidLogo" />
            <div class="bidAppName">{{ bidAppName }}</div>
            <div class="bidFuncName">{{ bidFuncName }}</div>
          </div>
          <div class="iframeHeadMain">
            <el-row>
              <el-col :span="12"
                ><div class="iframeHeadMainLi" :title="form.schemeCode">
                  项目编号：{{ form.schemeCode }}
                </div></el-col
              >
              <el-col :span="12"
                ><div
                  class="iframeHeadMainLi"
                  :title="form.schemeName"
                  style="padding-right: 210px;"
                >
                  项目名称：{{ form.schemeName }}
                </div></el-col
              >
              <el-col :span="12"
                ><div class="iframeHeadMainLi">
                  采购方式：{{ form.purchaseTypeName }}
                </div></el-col
              >
              <el-col :span="12"
                ><div class="iframeHeadMainLi" style="padding-right: 210px;">
                  承办人：{{ form.purchaseUnderName }}
                </div></el-col
              >
            </el-row>
          </div>
          <div class="iframe_btn">
            <a
              href="javascript:;"
              style="margin-right: 20px;"
              @click.prevent="handleReturnHome"
              ><svg-icon
                icon-class="returnWindow"
                class="window-icon-return"
              />返回桌面</a
            >
            <a href="javascript:;" @click.prevent="handleCloseWindow"
              ><svg-icon
                icon-class="closeWindow"
                class="window-icon-close"
              />关闭窗口</a
            >
          </div>
        </div>

        <div class="iframeBody">
          <div class="iframeMenu" v-if="menuShow">
            <div class="iframeMenuWrap">
              <div class="iframeMenuTitle">
                在线评标室
              </div>
              <div class="iframeMenuCon">
                <el-tree
                  icon-class="el-icon-caret-right icon-position"
                  ref="tree"
                  :data="menuData"
                  :props="defaultProps"
                  node-key="menuKey"
                  :highlight-current="true"
                  @node-click="handleNodeClick"
                >
                </el-tree>
              </div>
            </div>
          </div>
          <div class="iframeMain" :class="{ hideMenu: !menuShow }">
            <div class="iframeMain-box">
              <app-main style="min-height: auto;margin-left:0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppMain } from "./components";
// import bidFlowLogo from "@/basa/assets/images/expert-evaluate-flow-logo.png";
import { parentGetArgs } from "@/basa/utils";
import {
  queryPurchaseSchemeDetailApi,
  listBidEvaMenuApi,
  qryBidEvaProcessStatusApi,
  dealBidEvaCheckApi,
  dealBidEvaSignPictureCheckApi,
  getAiToken,
  querySmpcOrgOpenConfig
} from "@/app/sourcingFlow/api/expertEvaluation.js";
export default {
  name: "sourcingLayout",
  components: {
    AppMain
  },
  data() {
    return {
      // bidFlowLogo: bidFlowLogo,
      bidLogo:
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/BASA_main/10000121987%40117158/2021/1/6/e3c4684543fa48379707a88c94a087f1.png",
      bidAppName: JSON.parse(sessionStorage.getItem("userDetal")).agentName,
      // bidFuncName: JSON.parse(sessionStorage.getItem("expertSourceData"))
      //   .opUnitName,
      bidFuncName: "常用功能",
      defaultProps: {
        children: "children",
        label: "label"
      },
      form: {},
      menuShow: true,
      menuData: [
        {
          label: "专家签到",
          menuKey: "001",
          routerName: "expertsIn",
          leaf: true
        },
        {
          label: "承诺书确认",
          menuKey: "002",
          routerName: "letterCommitmentConfirm",
          leaf: true
        },
        {
          label: "开标情况",
          menuKey: "003",
          routerName: "bidOpenSituation",
          leaf: true
        },
        {
          label: "评分表制定",
          menuKey: "004",
          routerName: "scoreScaleDeveloped",
          leaf: true
        },
        {
          label: "评分项查看",
          menuKey: "005",
          routerName: "viewScoreItems",
          leaf: true
        },
        {
          label: "分包商符合性检查",
          menuKey: "006",
          routerName: "supplierComplianceInspection",
          leaf: true
        },
        {
          menuKey: "007",
          label: "分包商澄清",
          children: [
            {
              menuKey: "008",
              routerName: "issueClarificationNotice",
              label: "发布澄清通知",
              leaf: true
            },
            {
              menuKey: "009",
              routerName: "supplierClarificationLetter",
              label: "分包商澄清函",
              leaf: true
            }
          ]
        },
        {
          menuKey: "010",
          label: "专家评分",
          children: [
            {
              menuKey: "011",
              routerName: "skiiScore",
              label: "技术评分",
              leaf: true
            },
            {
              menuKey: "012",
              routerName: "commercialGrade",
              label: "商务评分",
              leaf: true
            },
            {
              menuKey: "013",
              routerName: "technicalScoreSummary",
              label: "技术评分汇总",
              leaf: true
            },
            {
              menuKey: "014",
              routerName: "summaryBusinessSkillsScores",
              label: "商务技术评分汇总",
              leaf: true
            },
            {
              menuKey: "015",
              routerName: "technicalBusinessScore",
              label: "技术商务评分",
              leaf: true
            }
          ]
        },
        {
          menuKey: "016",
          label: "评标报告",
          children: [
            {
              menuKey: "017",
              label: "评标报告编制",
              routerName: "bidEvaluationReportPreparation",
              leaf: true
            },
            {
              menuKey: "018",
              label: "评标报告确认",
              routerName: "bidEvaluationReportConfirm",
              leaf: true
            }
          ]
        }
      ],
      indexUrl: "sourcingFlow",
      isAuth: false
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$router.history.current.query.flowSrc) {
      this.menuShow = false;
    } else {
      this.menuShow = true;
    }
    this.getData();
  },
  methods: {
    getData() {
      listBidEvaMenuApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        this.menuData = res.data.data;
      });
      queryPurchaseSchemeDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        sessionStorage.setItem("purchaseType", res.data.data.purchaseType);
        sessionStorage.setItem("moneyTypeName", res.data.data.moneyTypeName);
        sessionStorage.setItem("opUnitId", res.data.data.opUnitId);
        let expertSourceData = JSON.parse(
          sessionStorage.getItem("expertSourceData")
        );
        if (!expertSourceData.baseAppId) {
          expertSourceData.baseAppId = res.data.data.baseAppId;
          sessionStorage.setItem(
            "expertSourceData",
            JSON.stringify(expertSourceData)
          );
        }
        querySmpcOrgOpenConfig({ unitId: res.data.data.opUnitId }).then(res => {
          this.isAuth = res.data.data;
        });
      });
      getAiToken({}).then(res => {
        sessionStorage.setItem("AItoken", res.data.data.Authorization);
      });
    },
    handleNodeClick(obj) {
      if (
        obj.menuKey !== "0808" &&
        obj.menuKey !== "0806" &&
        obj.menuKey !== "0807"
      ) {
        dealBidEvaCheckApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          stepCode: obj.menuKey
          // stepCode:
          //   obj.routerName === "supplierComplianceInspection"
          //     ? "0804"
          //     : obj.menuKey
        })
          .then(res => {
            if (res.data.code == "0") {
              qryBidEvaProcessStatusApi({
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                joinExpertId: JSON.parse(
                  sessionStorage.getItem("expertSourceData")
                ).joinExpertId,
                purStep:
                  obj.routerName === "supplierComplianceInspection" ||
                  obj.routerName === "subSupplierComplianceInspection"
                    ? "0804"
                    : obj.menuKey
              }).then(res => {
                sessionStorage.setItem(
                  "bidEvaProcessStatus",
                  JSON.stringify(res.data.data)
                );
                if (
                  (obj.routerName == "supplierComplianceInspection" ||
                    obj.routerName == "addCommercialGrade" ||
                    obj.routerName == "commercialGradeList" ||
                    obj.routerName == "addSkiiScore" ||
                    obj.routerName == "skiiScore" ||
                    obj.routerName == "commercialGrade" ||
                    obj.routerName == "technicalBusinessScore" ||
                    obj.routerName == "skiiScoreList") &&
                  JSON.parse(sessionStorage.getItem("expertSourceData"))
                    .baseAppId == "100126" &&
                  this.isAuth
                ) {
                  obj.routerName += "WZ";
                } else if (
                  obj.routerName == "supplierComplianceInspection" &&
                  JSON.parse(sessionStorage.getItem("expertSourceData"))
                    .baseAppId == "100126"
                ) {
                  obj.routerName += "WZCG";
                }
                // 跳转路由
                this.$router.push({
                  name: obj.routerName,
                  query: {
                    a: this.$router.history.current.query.a,
                    menuKey:
                      obj.routerName === "supplierComplianceInspectionWZ" ||
                      obj.routerName === "supplierComplianceInspection"
                        ? "0804"
                        : obj.menuKey
                  }
                });
              });
            } else {
              this.$router.push({
                name: this.indexUrl,
                query: {
                  a: this.$router.history.current.query.a,
                  menuKey: obj.menuKey
                }
              });
            }
          })
          .catch(res => {
            this.$router.push({
              name: this.indexUrl,
              query: {
                a: this.$router.history.current.query.a,
                menuKey: obj.menuKey
              }
            });
          });
      }
      if (
        obj.menuKey == "0802" ||
        obj.menuKey == "0806" ||
        obj.menuKey == "0807"
      ) {
        dealBidEvaSignPictureCheckApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          stepCode: this.$route.query.menuKey
        }).then(res => {
          if (res.data.data === 0) {
            this.$message({
              message: "检测到当前专家已签到未签名，请及时补充签名信息",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        });
      }
    },
    handleReturnHome() {
      this.$router.push({
        name: this.indexUrl,
        query: {
          a: this.$router.history.current.query.a
        }
      });
    },
    handleCloseWindow() {
      if (
        parentGetArgs("joinExpertId") &&
        parentGetArgs("schemeId") &&
        parentGetArgs("expertRole")
      ) {
        window.parent.close();
      } else {
        window.parent.postMessage(false, "*");
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/config/styles/mixin.scss";
@import "~@/config/styles/variables.scss";

html,
body {
  min-height: 100%;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.iframe_btn .window-icon-return {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.iframe_btn .window-icon-close {
  margin-right: 5px;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.no-print1 {
  display: none;
}
.iframeMenu {
  overflow: auto;
}
.iframeMenuCon {
  position: relative;
  padding-bottom: 20px;
}
.icon-position {
  position: relative;
  left: 130px;
}
.iframeMenuCon .el-tree-node__label {
  position: relative;
  left: -22px;
}
.icon-right {
  margin-right: 5px;
}
.iframe_btn {
  color: #ffffff;
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 14px;
}
.hideMenu {
  margin-left: 0 !important;
  padding-left: 0 !important;
}
</style>
